








































































































































































import {Component, Prop, Emit} from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import {DialogForm, FormOverlay} from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import UiLogout from '@/components/ui/ui-logout.vue';
import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';
import ModalHeader from '@/components/ui/ui-modal/modal/header.vue';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons,
    UiLogout,
    ModalHeader,
    ErrorAggregator,
  }
})
export default class UpdateBillingInfoDialog extends Form {
  @Prop({ default: {} })
  data: any;

  api: SubscriptionApi = subscriptionApi;

  show: boolean = false;
  edit: boolean = true;
  loading: boolean = false;
  billingInfo: any = {
    billing_address: {}
  }

  errors: any[] = [];
  errorsControlActive: boolean = false;

  @Emit('success')
  onSuccess() {}

  handleLogout() {
    const logout = this.$refs.logout as UiLogout;
    logout.showConfirm();
  }

  load(): any{
    this.$store.commit('loading', true);

    const customer: Promise<any> = this.api.getCustomer();

    return Promise.all([customer])
  }

  mounted() {
    this.$on('error', (e: any) => {
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });
    
    if (this.loading) return;

    this.loading = true; 

    this.load().then(() => {
      this.billingInfo = this.$store.state.billingCustomer.billingInfo;
      this.$store.commit('loading', false);
      this.loading = false;
      this.show = true;
    })
  }

  close() {
    this.$store.commit('loading', false);
    this.$emit('close');
  }

  @Send(true)
  save() {
    this.$store.commit('loading', true); 
    return this.api.postUpdateBillingInfo(this.billingInfo).then(() => {
      this.$emit('close');
      this.$store.commit('loading', false);
      this.bus.emit(
        'toast-success',
        this.t('Billing info successfully changed.')
      );
    });
  }
}
